import { Routes, Route, Navigate, useLocation, matchPath } from "react-router-dom";
import Footer from "../Footer/Footer";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setLoggedUser } from "../../store/actions/user";
import { ROLES } from "../../model/roles";
import { sidebarRoutes } from "../../model/sidebarRoutes";
import { createProtectedRoute } from "../createProtectedRoute/createProtectedRoute";
import UtilityService from "../../services/UtillityServices/UtilityService";

import CorsiPage from "../../pages/CorsiPage/CorsiPage";
import Navbar from "../Navbar/Navbar";
import AccediPage from "../../pages/AccediPage/AccediPage";
import RegistratiPage from "../../pages/RegistratiPage/RegistratiPage";
import CorsoDetailsPage from "../../pages/CorsoDetailsPage/CorsoDetailsPage";
import { useJwt } from "react-jwt";
import ProfilePage from "../../pages/ProfilePage/ProfilePage";
import { useSelector } from "react-redux";
import { authRoutes } from "../../model/authRoutes";

import CreaCorsoPage from "../../pages/CreaCorsoPage/CreaCorsoPage";
import GestioneCorsiPage from "../../pages/GestioneCorsiPage/GestioneCorsiPage";
import Sidebar from "../Sidebar/Sidebar";
import useMediaQuery from "../../hooks/useMediaQuery";
import AggiungiContenutiCorsoPage from "../../pages/AggiungiContenutiCorsoPage/AggiungiContenutiCorsoPage";
import GestioneUtentiPage from "../../pages/GestioneUtentiPage/GestioneUtentiPage";
import GestioneAgenziePage from "../../pages/GestioneAgenziePage/GestioneAgenziePage";
import GestioneSediPage from "../../pages/GestioneSediPage/GestioneSediPage";
import AssegnaCorsiPage from "../../pages/AssegnaCorsiPage/AssegnaCorsiPage";
import CheckoutPage from "../../pages/CheckoutPage/CheckoutPage";
import {Alert} from "../../components/Alert/Alert";
import ReturnCheckoutPage from "../../pages/ReturnCheckoutPage/ReturnCheckoutPage";
import AreaPersonaleClassiPage from "../../pages/AreaPersonaleClassiPage/AreaPersonaleClassiPage";
import AreaPersonaleCorsiPage from "../../pages/AreaPersonaleCorsiPage/AreaPersonaleCorsiPage";
import InvitaAmicoPage from "../../pages/InvitaAmicoPage/InvitaAmicoPage";
import ForgotPasswordPage from "../../pages/ForgotPasswordPage/ForgotPasswordPage";
import GestioneCorsiUtentiPage from "../../pages/GestioneCorsiUtentiPage/GestioneCorsiUtentiPage";
import BlacklistPage from "../../pages/BlacklistPage/BlacklistPage";
import QuizExecutionPage from "../../pages/QuizExecutionPage/QuizExecutionPage";
import SurveyCreatorPage from "../../pages/SurveyCreatorPage/SurveyCreatorPage";
import HomePage from "../../pages/HomePage/HomePage";
import useAuth from "../../hooks/useAuth";
import LezioniConfigPage from "../../pages/LezioniConfigPage/LezioniConfigPage";
import PresenzePage from "../../pages/PresenzePage/PresenzePage";
import GestioneClassiPageV2 from "../../pages/GestioneClassiPage/GestioneClassiPageV2";
import GestioneClassiUtentiPage from "../../pages/GestioneClassiUtentiPage/GestioneClassiUtentiPage";
import ArgomentiPage from "../../pages/ArgomentiPage/ArgomentiPage";
import EsamiConfigPage from "../../pages/EsamiConfigPage/EsamiConfigPage";
import GestioneTicketPage from "../../pages/GestioneTicketPage/GestioneTicketPage";
import TicketPage from "../../pages/TicketPage/TicketPage";
import AreaPersonaleTicketPage from "../../pages/AreaPersonaleTicketPage/AreaPersonaleTicketPage";
import AreaPersonaleLezioniPage from "../../pages/AreaPersonaleLezioniPage/AreaPersonaleLezioniPage";
import AreaPersonaleEsamiPage from "../../pages/AreaPersonaleEsamiPage/AreaPersonaleEsamiPage";
import GestioneRisultatiEsamePage from "../../pages/GestioneRisultatiEsamePage/GestioneRisultatiEsamePage";
import GestioneCertificazioniPage from "../../pages/GestioneCertificazioniPage/GestioneCertificazioniPage";
import AreaPersonaleClassePage from "../../pages/AreaPersonaleClassePage/AreaPersonaleClassePage";
import GestioneContabilizzazioniPage from "../../pages/GestioneContabilizzazioniPage/GestioneContabilizzazioniPage";
import AreaPersonaleCorsoPage from "../../pages/AreaPersonaleCorsoPage/AreaPersonaleCorsoPage";
import ContabilizzazioniPage from "../../pages/ContabilizzazioniPage/ContabilizzazioniPage";
import RendicontazionePage from "../../pages/RendicontazionePage/RendicontazionePage";
import GestioneSuperpartnerPage from "../../pages/GestioneSuperpartnerPage/GestioneSuperpartnerPage";
import DashboardRendicontazioneAdminPage from "../../pages/DashboardRendicontazioneAdminPage/DashboardRendicontazioneAdminPage";
import ArchivioRendicontazioniPage from "../../pages/ArchivioRendicontazioniPage/ArchivioRendicontazioniPage";
import VetrinaCorsiPage from "../../pages/VetrinaCorsiPage/VetrinaCorsiPage";
import DashboardRendicontazioneSuperpartnerPage from "../../pages/DashboardRendicontazioneSuperpartnerPage/DashboardRendicontazioneSuperpartnerPage";
import ArchivioRendicontazioniSuperpartnerPage from "../../pages/ArchivioRendicontazioniSuperpartnerPage/ArchivioRendicontazioniSuperpartnerPage";
import VoucherAgenziaPage from "../../pages/VoucherAgenziaPage/VoucherAgenziaPage";


function Security() {
  const { getUserInfoLoggedIn, isLoading: isLoadingAuth } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const { decodedToken } = useJwt(localStorage.getItem("token"));
  const user = useSelector((state) => state.user.userData);
  const location = useLocation();
  const isAuthRoutes = authRoutes.includes(location.pathname);
  const isSidebarRoutes = sidebarRoutes.includes(location.pathname);
  const isWideScreen = useMediaQuery("(min-width: 1200px)");
  const collapsedState = useSelector(state => state?.sidebarCollapse);
  const isTicketRoute = matchPath('/ticket/:idTicket', location.pathname);

  useEffect(() => {
    setIsLoading(true);
    if (decodedToken) {
      getUserInfo(decodedToken);
    }
    setIsLoading(false);
  }, [decodedToken, dispatch]);

  const getUserInfo = async (decodedToken) => {
    const userInfo = await getUserInfoLoggedIn();
    const user = {
     ...decodedToken,
     ...userInfo
    }
    dispatch(setLoggedUser(user));
  }


  if (isLoading || isLoadingAuth) {
    return (
      <>
      <div
        className={"d-flex align-items-center justify-content-center vh-100"} style={{backgroundColor: isSidebarRoutes ? "#E9EAED" : "white"}}>
        <Spinner />
      </div>
      </>
    );
  } 
  
  if(!isLoading && !isLoadingAuth) {
    return (
      <>
      <Navbar />
      <Alert />
      {(user?.sub && (isSidebarRoutes || isTicketRoute)) && (
      <Sidebar/>
      )}
    
      <div   id="root" style={{minHeight: user?.sub && (isAuthRoutes || isTicketRoute) && "100vh", backgroundColor: user?.sub && (isAuthRoutes || isTicketRoute) && "#E9EAED"}} >
    <div className={`
        ${!isSidebarRoutes && !isTicketRoute && isAuthRoutes ? "container" : ""}
        ${user?.sub && (isSidebarRoutes || isTicketRoute) && (isAuthRoutes || isTicketRoute) ? "card-container" : ""}
        ${user?.sub && collapsedState && (isSidebarRoutes || isTicketRoute) ? "content-sm" : ""}
        ${user?.sub && (isSidebarRoutes || isTicketRoute) && isWideScreen && !collapsedState ? "content-lg" : ""}
        ${user?.sub &&
        (isSidebarRoutes || isTicketRoute) && !isWideScreen? "content-sm" : ""}
        `}
        style={{
          flex: 1,
          padding: isWideScreen && (isSidebarRoutes || isTicketRoute) ? "20px 30px" : "",
        }}>
      <Routes>
      {/*    <Route path="/home" element={<HomePage />} /> */}
        {
          user?.sub && (
            <>
            <Route path="/corsi" element={<CorsiPage />} />
            <Route path="/corso/:idCorso" element={<CorsoDetailsPage />} />
            <Route path="/profilo" element={<ProfilePage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/return-checkout" element={<ReturnCheckoutPage />} />
            {createProtectedRoute('/survey-creator', <SurveyCreatorPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))}
            {createProtectedRoute('/test-survey', <QuizExecutionPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.CORSISTA]))}
            {createProtectedRoute('/crea-corso', <CreaCorsoPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER]))} 
            {createProtectedRoute('/aggiungi-contenuti', <AggiungiContenutiCorsoPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/assegna-corsi', <AssegnaCorsiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.PARTNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/configura-argomenti', <ArgomentiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/configura-lezioni', <LezioniConfigPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/configura-esami', <EsamiConfigPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/registro-presenze', <PresenzePage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/gestione-corsi-utenti', <GestioneCorsiUtentiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.PARTNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/gestione-classi-utenti', <GestioneClassiUtentiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/gestione-corsi', <GestioneCorsiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE, ROLES.PARTNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/gestione-utenti', <GestioneUtentiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.PARTNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/gestione-ticket', <GestioneTicketPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE, ROLES.TUTOR]))} 
            {createProtectedRoute('/gestione-contabilizzazioni', <GestioneContabilizzazioniPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/contabilizzazioni', <ContabilizzazioniPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.PARTNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/gestione-certificazioni', <GestioneCertificazioniPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE, ROLES.TUTOR]))} 
            {createProtectedRoute('//gestione-risultati-esame', <GestioneRisultatiEsamePage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/ticket/:idTicket', <TicketPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE, ROLES.TUTOR, ROLES.CORSISTA]))} 
            {createProtectedRoute('/blacklist-utenti', <BlacklistPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/gestione-agenzie', <GestioneAgenziePage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/gestione-sedi', <GestioneSediPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER]))} 
            {createProtectedRoute('/gestione-classi', <GestioneClassiPageV2 />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER, ROLES.COURSE_DESIGNER, ROLES.DOCENTE]))} 
            {createProtectedRoute('/area-personale/corsi', <AreaPersonaleCorsiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA]))} 
            {createProtectedRoute('/area-personale/corso', <AreaPersonaleCorsoPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA]))} 
            {createProtectedRoute('/area-personale/calendario/esami', <AreaPersonaleEsamiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA, ROLES.TUTOR]))} 
            {createProtectedRoute('/area-personale/calendario/lezioni', <AreaPersonaleLezioniPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA, ROLES.TUTOR]))} 
            {createProtectedRoute('/area-personale/classi', <AreaPersonaleClassiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.TUTOR]))} 
            {createProtectedRoute('/area-personale/classe', <AreaPersonaleClassePage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA]))} 
            {createProtectedRoute('/area-personale/ticket', <AreaPersonaleTicketPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA]))} 
            {createProtectedRoute('/area-personale/invita-amico', <InvitaAmicoPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.CORSISTA, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/area-personale/voucher', <VoucherAgenziaPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.PARTNER]))}
            {createProtectedRoute('/rendicontazione', <RendicontazionePage />, () => UtilityService?.isInGroup(user?.role, [ROLES.PARTNER, ROLES.SUPERPARTNER]))}
            {createProtectedRoute('/gestione-superpartner', <GestioneSuperpartnerPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/dashboard-rendicontazione-admin', <DashboardRendicontazioneAdminPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/archivio-rendicontazioni', <ArchivioRendicontazioniPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/vetrina-corsi', <VetrinaCorsiPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.SUPERPARTNER]))} 
            {createProtectedRoute('/dashboard-rendicontazione-superpartner', <DashboardRendicontazioneSuperpartnerPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 
            {createProtectedRoute('/archivio-rendicontazioni-superpartner', <ArchivioRendicontazioniSuperpartnerPage />, () => UtilityService?.isInGroup(user?.role, [ROLES.ADMIN, ROLES.DEVELOPER]))} 

            <Route path="/" element={<ProfilePage />}/>
            <Route path="*" element={<ProfilePage />} />
            </>
          ) 
        }
          
      {  !user?.sub && !decodedToken && (
            <>
            <Route path="/corsi" element={<CorsiPage />} />
            <Route path="/corso/:idCorso" element={<CorsoDetailsPage />} />
            <Route path="/accedi" element={<AccediPage />} />
            <Route path="/registrati" element={<RegistratiPage />} />
            <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
            <Route path="/" element={<AccediPage />} />
            <Route path="*" element={<AccediPage />} />
            </>
          )}
        </Routes>
        </div>
      </div>
        {(!isSidebarRoutes && !isTicketRoute) && (
          <Footer />
        )}
      </>
    )
  }
}

export default Security;
